const api = {
	url: {
		BASE_URL: 'https://algorithmvisualizer.onrender.com/api/',
	},
};


export const config =  api;